export const accordion = {
  header: {
    color: '{surface.0}',
    hoverColor: '{surface.0}',
    activeColor: '{surface.0}',
    padding: '0',
    fontWeight: '700',
    borderRadius: '0',
    borderWidth: '0px',
    borderColor: '{content.border.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
    toggleIcon: {
      color: '{text.muted.color}',
      hoverColor: '{text.color}',
      activeColor: '{text.color}',
      activeHoverColor: '{text.color}',
    },
    first: {
      topBorderRadius: '0px',
      borderWidth: '0px',
    },
    last: {
      bottomBorderRadius: '0px',
      activeBottomBorderRadius: '0px',
    },
  },
  content: {
    borderWidth: '0px',
    background: 'rgba(0, 0, 0, 0)',
    padding: '0.4rem 0rem 0rem 0rem',
  },
  colorScheme: {
    dark: {
      header: {
        background: 'rgba(0, 0, 0, 0)',
        activeBackground: 'rgba(0, 0, 0, 0)',
        hoverBackground: 'rgba(0, 0, 0, 0)',
        activeHoverBackground: 'rgba(0, 0, 0, 0)',
      },
    },
  },
}
